import { Questionnaire } from '@medplum/fhirtypes';

/**
 * Retrieves the question text from a Questionnaire by linkId
 * @param questionnaire - The Questionnaire resource
 * @param linkId - The linkId of the question
 * @returns The question text, or undefined if not found
 */
export function getQuestionText(
  questionnaire: Questionnaire | undefined,
  linkId: string
): string | undefined {
  if (!questionnaire?.item) {
    return undefined;
  }

  const findItem = (items: typeof questionnaire.item): string | undefined => {
    for (const item of items || []) {
      if (item.linkId === linkId) {
        return item.text;
      }
      // Recursively search in nested items
      if (item.item) {
        const found = findItem(item.item);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  };

  return findItem(questionnaire.item);
}
